import type { AccessConstraint } from '@sb/shared/access';
import { PlanType } from '@shiftbase-com/ts-shared/models';

/** Access constraints for the timetracking-settings routes. */
const timetrackingBase = { permission: ['Manage account'] } satisfies AccessConstraint;

export const timetrackingSettingsAccess = {
  notifications: { ...timetrackingBase, subscriptionPlan: PlanType.BASIC },
  'custom-fields': { ...timetrackingBase, subscriptionPlan: PlanType.PREMIUM },
  clocking: { ...timetrackingBase, subscriptionPlan: PlanType.BASIC },
  'break-rules': { ...timetrackingBase, subscriptionPlan: PlanType.BASIC },
  restrictions: { ...timetrackingBase, subscriptionPlan: PlanType.PREMIUM },
} satisfies Record<string, AccessConstraint>;
